'use client';

import { useAuiEvent } from '@assistant-ui/react';

import { confirmDeletions, getAllPendingDeletions } from '@/lib/utils/deletion-queue';

export function useDeletionConfirmation(): void {
  useAuiEvent('thread.runEnd', async () => {
    const pending = await getAllPendingDeletions();
    if (pending.length) {
      await confirmDeletions(pending);
    }
  });
}
